import punishmentListReducer from "./reducers";
export { default as punishmentListTypes } from "./types";
export { default as punishmentListOperations } from "./operations";
export default punishmentListReducer;
